import { TileSet, type TileDef } from "../../engine/world/Tiles";

/**
 * The demo's terrain palette. Everything a map can be made of is here; maps
 * themselves are ASCII art that references these ids through a legend.
 */
export const TILES: TileDef[] = [
  { id: "grass", color: 0x5aa84a, sideColor: 0x3e7a34 },
  { id: "grass-flowers", color: 0x5aa84a, sideColor: 0x3e7a34, prop: "flower" },
  { id: "path", color: 0xc4a874, sideColor: 0x9a8256, encounterScale: 0.6 },
  { id: "sand", color: 0xe0cf95, sideColor: 0xb5a370, encounterScale: 1.2 },
  { id: "forest", color: 0x3d8a3f, sideColor: 0x2c6630, prop: "tree", encounterScale: 1.6 },
  // Impassable treeline, used to fence in towns.
  { id: "thicket", color: 0x2c6630, sideColor: 0x1f4a24, height: 0.9, solid: true, prop: "tree" },
  { id: "pines", color: 0x357a45, sideColor: 0x27573a, prop: "pine", encounterScale: 1.6 },
  { id: "hill", color: 0x7a9a52, sideColor: 0x5b7440, height: 0.55, solid: true },
  { id: "mountain", color: 0x8a8378, sideColor: 0x6f6960, height: 1.25, solid: true },
  { id: "rocks", color: 0x6f8a52, sideColor: 0x53673f, prop: "rock", encounterScale: 1.3 },
  { id: "water", color: 0x2f6fd0, sideColor: 0x24509a, animated: true, solid: true },
  { id: "shallows", color: 0x4f9ae0, sideColor: 0x3776ad, animated: true, encounterScale: 1.4 },

  // Town
  { id: "town-floor", color: 0xb8a582, sideColor: 0x8e7c5f, encounterScale: 0 },
  { id: "cobble", color: 0x9a9a9a, sideColor: 0x707070, encounterScale: 0 },
  { id: "wall", color: 0xd8c9a8, sideColor: 0xb8aa8c, height: 1.3, solid: true },
  { id: "roof", color: 0xbf4a3a, sideColor: 0x9b3c2e, height: 1.7, solid: true },
  { id: "fence", color: 0x8a6a3a, sideColor: 0x6b5029, height: 0.6, solid: true },
  { id: "door", color: 0x7a4a22, sideColor: 0x5c3719, height: 1.2, solid: true },
  { id: "doorway", color: 0x3a2412, sideColor: 0x281a0d, encounterScale: 0 },
  { id: "inn-floor", color: 0x9a7048, sideColor: 0x745334, encounterScale: 0 },
  { id: "bed", color: 0xe8e4d8, sideColor: 0xb04a4a, height: 0.35, solid: true },
  { id: "signpost", color: 0xb8a582, sideColor: 0x8e7c5f, solid: true, prop: "sign", encounterScale: 0 },
  { id: "garden", color: 0x5aa84a, sideColor: 0x3e7a34, prop: "flower", encounterScale: 0 },
  { id: "well", color: 0x9a9a9a, sideColor: 0x707070, height: 0.5, solid: true },

  // Cave
  { id: "cave-floor", color: 0x574d5e, sideColor: 0x3c3542, encounterScale: 1 },
  { id: "cave-wall", color: 0x3a3340, sideColor: 0x342d3c, height: 1.8, solid: true },
  { id: "cave-crystal", color: 0x574d5e, sideColor: 0x3c3542, prop: "crystal", propColor: 0x66e0ff },
  { id: "cave-torch", color: 0x574d5e, sideColor: 0x3c3542, prop: "torch", encounterScale: 0.5 },
  { id: "lava", color: 0xd2541f, sideColor: 0x8c3510, animated: true, solid: true },
  { id: "graves", color: 0x4a4a52, sideColor: 0x33333a, prop: "grave", encounterScale: 1.5 },
];

export const tileset = new TileSet(TILES);
